module.exports = __webpack_public_path__ + "cambodia.svg?952f3476788db33689311c9aa0c480e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/cambodia.svg
// module id = 125
// module chunks = 10